import React from 'react';

import { IconPropsType } from 'designSystem/types/icons';

interface IDownloadIconProps extends IconPropsType {}

const DownloadIcon = ({
  size = 20,
  fill = '#fffff',
  ...props
}: IDownloadIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.5 11.875V17.2083C1.5 17.3851 1.57024 17.5547 1.69526 17.6797C1.82029 17.8048 1.98985 17.875 2.16667 17.875H16.8333C17.0101 17.875 17.1797 17.8048 17.3047 17.6797C17.4298 17.5547 17.5 17.3851 17.5 17.2083V11.875C17.5 11.6982 17.4298 11.5286 17.3047 11.4036C17.1797 11.2786 17.0101 11.2083 16.8333 11.2083C16.6565 11.2083 16.487 11.2786 16.3619 11.4036C16.2369 11.5286 16.1667 11.6982 16.1667 11.875V16.5417H2.83333V11.875C2.83333 11.6982 2.7631 11.5286 2.63807 11.4036C2.51305 11.2786 2.34348 11.2083 2.16667 11.2083C1.98985 11.2083 1.82029 11.2786 1.69526 11.4036C1.57024 11.5286 1.5 11.6982 1.5 11.875ZM9.97167 12.3467C9.90975 12.4087 9.83623 12.4578 9.75529 12.4914C9.67436 12.5249 9.58761 12.5422 9.5 12.5422C9.41239 12.5422 9.32564 12.5249 9.24471 12.4914C9.16377 12.4578 9.09025 12.4087 9.02833 12.3467L5.695 9.01333C5.63306 8.95139 5.58393 8.87786 5.5504 8.79693C5.51688 8.716 5.49963 8.62926 5.49963 8.54167C5.49963 8.45407 5.51688 8.36733 5.5504 8.2864C5.58393 8.20547 5.63306 8.13194 5.695 8.07C5.75694 8.00806 5.83047 7.95893 5.9114 7.9254C5.99233 7.89188 6.07907 7.87463 6.16667 7.87463C6.25426 7.87463 6.341 7.89188 6.42193 7.9254C6.50286 7.95893 6.57639 8.00806 6.63833 8.07L8.83333 10.2658V2.54167C8.83333 2.36486 8.90357 2.19529 9.02859 2.07026C9.15362 1.94524 9.32319 1.875 9.5 1.875C9.67681 1.875 9.84638 1.94524 9.9714 2.07026C10.0964 2.19529 10.1667 2.36486 10.1667 2.54167V10.2658L12.3617 8.07C12.4868 7.94491 12.6564 7.87463 12.8333 7.87463C13.0102 7.87463 13.1799 7.94491 13.305 8.07C13.4301 8.19509 13.5004 8.36476 13.5004 8.54167C13.5004 8.71858 13.4301 8.88824 13.305 9.01333L9.97167 12.3467Z"
      fill="white"
    />
  </svg>
);

export default DownloadIcon;
